import FormattedMessage from 'I18n/components/FormattedMessage';
import { CallingIcon } from 'foundations-assets/icons/components/CallingIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { breakpoint } from '../constants/Breakpoints';
import { getFormattedPhoneNumber, getPhoneNumberUrl } from './phoneSupportUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLink = styled.div.withConfig({
  displayName: "PhoneNumber__StyledLink"
})(() => {
  return {
    [breakpoint.tablet]: {
      display: 'inline-block'
    }
  };
});
function PhoneNumber({
  phoneNumber,
  countryCode,
  onPhoneNumberClick,
  hideInitially = false,
  onShowPhoneNumberClick
}) {
  const [showPhoneNumber, setShowPhoneNumber] = useState(!hideInitially);
  const handlePhoneNumberClick = event => {
    onPhoneNumberClick === null || onPhoneNumberClick === void 0 || onPhoneNumberClick(event);
  };
  const handleShowPhoneNumberClick = event => {
    onShowPhoneNumberClick === null || onShowPhoneNumberClick === void 0 || onShowPhoneNumberClick(event);
    setShowPhoneNumber(true);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingBlock: "400",
    paddingInline: "0",
    marginBlock: "0",
    marginInline: "auto",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: CallingIcon,
      paddingInlineStart: "0",
      color: "text-interactive-default",
      size: "400",
      paddingInlineEnd: "100",
      marginBlockStart: "100"
    }), /*#__PURE__*/_jsx(StyledLink, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: showPhoneNumber ? /*#__PURE__*/_jsx(Link, {
          href: getPhoneNumberUrl(countryCode, phoneNumber),
          onClick: handlePhoneNumberClick,
          children: getFormattedPhoneNumber(countryCode, phoneNumber)
        }, "phone-number") : /*#__PURE__*/_jsx(Link, {
          onClick: handleShowPhoneNumberClick,
          "data-selenium-id": "phone-number",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-page-components.phone-support.seePhoneNumber"
          })
        })
      })
    }, "phone-number")]
  });
}
export default PhoneNumber;